import { HH_MODULE } from "./constants"

export enum SurveyMode {
  INFORM = 1,
  KOBO = 2,
  MODA = 3,
  MODAETH = 4,
  CSV = 5,
}

export enum FrequencyMode {
  OnceADay = 2,
  TwiceADay = 3,
  OnceAWeek = 5,
  TwiceAWeek = 6,
  OnceAMonth = 7,
}

export enum SurveyVisibility {
  "Draft-Internal" = 1,
  "Official-Use" = 2,
  Public = 3,
}

export const frequencyOptions = [
  { value: 8, label: "Every 1 hour" },
  { value: 1, label: "Every 2 hours" },
  { value: FrequencyMode.OnceADay, label: "Once a day" },
  { value: FrequencyMode.TwiceADay, label: "Twice a day" },
  { value: 4, label: "Every 2 days" },
  { value: FrequencyMode.OnceAWeek, label: "Once a week" },
  { value: FrequencyMode.TwiceAWeek, label: "Twice a week" },
  { value: FrequencyMode.OnceAMonth, label: "Once a month" },
]
export const weekOptions = [
  { value: 1, label: "Monday" },
  { value: 2, label: "Tuesday" },
  { value: 3, label: "Wednesday" },
  { value: 4, label: "Thursday" },
  { value: 5, label: "Friday" },
  { value: 6, label: "Saturday" },
  { value: 7, label: "Sunday" },
]
export const dayOptions = [...Array(31)].map((_, i) => ({ value: i + 1, label: `${i + 1}` }))

export const permissionsHH = {
  moduleId: HH_MODULE,
  subModule: "surveys",
}

export const settingsTabs = [
  { label: "Categories", href: "", role: "tab", selected: true, tabIndex: 0, type: "category", withFilter: false },
  { label: "Types", href: "", role: "tab", selected: false, tabIndex: 1, type: "type", withFilter: true },
  { label: "Modalities", href: "", role: "tab", selected: false, tabIndex: 2, type: "modality", withFilter: false },
  { label: "Attributes", href: "", role: "tab", selected: false, tabIndex: 3, type: "attribute", withFilter: false },
  {
    label: "Organizations",
    href: "",
    role: "tab",
    selected: false,
    tabIndex: 4,
    type: "organization",
    withFilter: false,
  },
]
